import { Link, NavLink } from "react-router-dom"
import { routes } from "../../../routes/router";
import { PhoneIcon, MapPinIcon, EnvelopeIcon } from "@heroicons/react/24/outline";
import { BiLogoWhatsapp } from 'react-icons/bi';
import { BsFacebook, BsLinkedin, BsWhatsapp, BsYoutube, BsInstagram } from "react-icons/bs";
export const Footer = () => {
    const currentYear = new Date().getFullYear();
    return (
        <div className="footer">
            <div className="container">
                <div className="footer-center">
                    <address className="address-group">
                        <h3>Get in Touch</h3>
                        <p className="footer-content">
                            Discover how MyGen Global Education Consultants can help you unlock your potential and achieve your international education dreams.
                            Contact us today to learn more about our services and expertise.
                        </p>
                        <div className="address">
                            <PhoneIcon className="address-icon" />
                            <div>+91 7299836888</div>
                        </div>
                        <div className="address">
                            <BiLogoWhatsapp size={32} />
                            <Link
                                to="https://wa.me/9677177296"
                                target="_blank"
                                rel="noopener noreferrer"
                            >+91 9677177296</Link>
                        </div>
                        <div className="address">
                            <MapPinIcon className="address-icon" />
                            <div>
                                MyGen Global Education <br />
                                Tidel Park, Pattabiram, <br />Thiruvallur High Road, Avadi, <br />Chennai - 600016
                            </div>
                        </div>
                        <div className="address">
                            <EnvelopeIcon className="address-icon" />
                            <a href="mailto:mygenglobalexpert@gmail.com">

                                <div>
                                    mygenglobalexpert@gmail.com
                                </div>
                            </a>
                        </div>
                    </address>
                    <nav className="footer-nav">
                        <h3>Quick links</h3>
                        <ul className="footer-nav-list">
                            {
                                routes.map((navItem, i) => (
                                    navItem.label ? (
                                        <li key={i} className="footer-nav-list-item">
                                            <NavLink to={navItem.path} className={({ isActive }) => isActive ? "active" : ""}>
                                                {navItem.label}
                                            </NavLink>
                                        </li>
                                    ) : null
                                ))
                            }

                        </ul>

                        <div className="social-network">
                            <ul>
                                <li>
                                    <Link
                                        to="https://www.linkedin.com/"
                                        target="_blank"
                                        rel="noopener noreferrer">
                                        <BsLinkedin size={45} />
                                    </Link>
                                </li>
                                 <li>
                                    <Link
                                        to="https://www.facebook.com/"
                                        target="_blank"
                                        rel="noopener noreferrer">
                                        <BsFacebook size={45} />
                                    </Link>
                                </li>
                               
                                
                                <li>
                                    <Link to="https://wa.me/9677177296"
                                        target="_blank"
                                        rel="noopener noreferrer">
                                        <BsWhatsapp size={45} />
                                    </Link>
                                </li>
                               
                                <li>
                                    <Link
                                        to="https://www.youtube.com/@Kaviarasanp-ky4ii"
                                        rel="noopener noreferrer"
                                        target="_blank">
                                        <BsYoutube size={45} />
                                    </Link>
                                </li>

                                 <li>
                                                                    <Link
                                                                        to="https://www.instagram.com/mygen_global?utm_source=qr&igsh=a2FjOTBoNDFicnk5"
                                                                        rel="noopener noreferrer"
                                                                        target="_blank">
                                                                        <BsInstagram size={45}  />

                                                                    </Link>
                                                                </li>
                                 


                            </ul>
                        </div>
                    </nav>
                </div>

            </div>
            <div className="footer-bottom">
                <div className="container">
                    <div className="footer-left">
                        {/* <img src="header/logo.svg" className="footer-logo" /> */}

                        <p>&copy; {currentYear} MyGenglobal. All rights reserved.</p>
                    </div>

                    <div className="footer-right">
                        <ul className="footer-nav-list">
                            <li><NavLink to="/">Privacy Policy</NavLink></li>
                            <li><NavLink to="/">Terms and Condition</NavLink></li>
                            <li><NavLink to="/">Contact Us</NavLink></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default Footer
